import clsx, { type ClassValue } from 'clsx';

/**
 * Thin `clsx` wrapper so call sites import one project-local helper instead
 * of the library directly. No `tailwind-merge`: components in this codebase
 * do not accept conflicting Tailwind classes from callers, so last-one-wins
 * class order is never in question. Add `tailwind-merge` here if that
 * changes rather than working around it at call sites.
 */
export function cn(...inputs: ClassValue[]): string {
  return clsx(...inputs);
}
